import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsAccountWhitelist } from "@/models/admin/warrantsAccountWhitelist/warrantsAccountWhitelist"
import { IWarrantsAccountWhitelist } from "@/models/admin/warrantsAccountWhitelist/warrantsAccountWhitelist.types"

/**
 * A single `warrants_accounts_whitelist` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Accounts_Whitelist` row; kept as a narrow type
 * so the parser only depends on the columns it actually reads.
 */
export type WarrantsAccountWhitelistRaw = {
  id: number
  account_number: string
  created_at: string
  deleted_at?: string | null
}

export const WarrantsAccountWhitelistParser: IParser<
  IWarrantsAccountWhitelist,
  WarrantsAccountWhitelistRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsAccountWhitelist(
        data.id,
        data.account_number,
        dayjsUTC(data.created_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
